import { HttpClient } from '@angular/common/http';
import { ResponseObject } from '@app/shared/models/response-object';
import { UserSentCoin, UserSentCoinEdit } from '@app/shared/models/user-sent-coin';
import { environment } from '@env/environment';
import { Observable, catchError, map, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';

export class UsersSentCoinApi {
  apiUrl = environment.API_URL;

  constructor(
    public readonly http: HttpClient,
    public config: ApiClientConfig
  ) {}

  // mock data
  getUsersSentCoin(size?: number): Observable<UserSentCoin[]> {
    return this.http.get<ResponseObject>('assets/mock/sent-coin-list.json').pipe(
      timeout(this.config.responseTimeout),
      map(res => {
        let usersSentCoin = localStorage.getItem('usersSentCoin');
        if (!usersSentCoin) {
          localStorage.setItem('usersSentCoin', JSON.stringify(res.data));
          return res.data;
        }
        usersSentCoin = JSON.parse(usersSentCoin);
        if (size && usersSentCoin) {
          usersSentCoin = usersSentCoin.slice(0, size);
        }
        return usersSentCoin;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  create(user: UserSentCoin): Observable<ResponseObject> {
    return this.http.post<ResponseObject>(this.apiUrl + '/user-sent-coin/add', JSON.stringify(user)).pipe(
      timeout(this.config.responseTimeout),
      catchError(error => {
        throw error.error;
      })
    );
  }

  update(data: UserSentCoinEdit): Observable<UserSentCoin> {
    return this.http
      .put<ResponseObject>(
        'https://dummyjson.com' + '/todos/' + data.id,
        JSON.stringify({
          [data.key]: data.value
        })
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map(res => {
          const usersSentCoin = localStorage.getItem('usersSentCoin');
          if (usersSentCoin) {
            const dataFormat = JSON.parse(usersSentCoin);
            dataFormat[data.index][data.key] = data.value;
            localStorage.setItem('usersSentCoin', JSON.stringify(dataFormat));
          }
          return res.data;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  delete(id: string) {
    return this.http.delete<ResponseObject>(this.apiUrl + '/user-sent-coin/' + id).pipe(
      timeout(this.config.responseTimeout),
      catchError(error => {
        throw error.error;
      })
    );
  }
}
